/* src/app/components/shared/model/confirm-dialog/confirm-dialog.component.css */
/*# sourceMappingURL=confirm-dialog.component.css.map */
